/**
 * All about form submission and validation
 */
import {
    appendNode, getFormValuesShallow,
    hideAll,
    revealNode,
    tryHideSelector,
    tryRevealSelector
} from "./dom-utils";
import {ajaxPost} from "./ajax";

function hideErrors(form) {
    const formErrors = form.querySelector('.form__errors')
    hideAll(formErrors.children)
}

function tryDisplayError(form, response) {
    const respJson = JSON.parse(response.responseText)
    const formErrors = form.querySelector('.form__errors')
    const errorCode = respJson['error/code']
    const errorCode2 = (errorCode && errorCode.replace(/.*\//, ""))
    if ((!errorCode && !respJson.body) || !formErrors) {
        return
    }

    tryRevealSelector('.form__item--errors', form)
    if (errorCode) {
        const serverError = formErrors.querySelector('[data-error-code="' + errorCode + '"]')
        const serverError2 = formErrors.querySelector('[data-error-code="' + errorCode2 + '"]')
        revealNode(serverError || serverError2)
    } else if (respJson.body) {
        const serverError = formErrors.querySelector('.raw') || appendNode(formErrors, {className: 'raw'})
        serverError.textContent = respJson.body
        revealNode(serverError)
    }
}

function tryShowSuccessMessage(form) {
    tryRevealSelector('.form__item--success', form)
    tryHideSelector('.form__controls', form)
}

function reportError(form, xhr) {
    const reachGoal = window.reachGoal
    if (!reachGoal) { return }
    reachGoal(form.dataset.errorGoalId || 'form--error')
}

function tryReachSuccessGoal(form) {
    const reachGoal = window.reachGoal
    if (!reachGoal) { return }
    reachGoal(form.dataset.goalId || 'form--success')
}



export function handleSubmit(e) {
    e.preventDefault()
    const form   = e.target
    const values = getFormValuesShallow(form)
    hideErrors(form)
    ajaxPost(form.action, values, {
        parseRespJson: true,
        onError: (xhr) => {
            console.error('ajaxPost : error : ', xhr)
            reportError(form, xhr)
            if ((xhr.status >= 400) && (xhr.status < 500)) {
                tryDisplayError(form, xhr)
            }
        },
        onSuccess: (xhr) => {
            if (![200].includes(xhr.status)) { return }
            const respJson = xhr.responseJSON || {}
            const targetLocation = respJson.location
            tryShowSuccessMessage(form)
            tryReachSuccessGoal(form)

            if (targetLocation) {
                const timeout = respJson['advised-timeout'] || 1
                setTimeout(() => {
                    location.assign(targetLocation)
                }, timeout)
            }
        }
    })
}